export default __webpack_public_path__ + "static/media/1.700b6391.png";